import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const first = document.getElementById('hero-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-15" data-mp="goayjbt6l9c8">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:bottom-4 sm:left-auto sm:right-4 sm:px-0 sm:pb-0" data-id="element-16" data-mp="bqsrjqyq546v">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex min-h-[60px] w-full items-center justify-center gap-3 rounded-2xl border-2 border-ink bg-gold px-6 py-3 text-center text-[17px] font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(11,27,46,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-ink/30 sm:w-auto" data-id="element-17" data-mp="2b3i8yjo2zvp1">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-18" data-mp="1rderyk85bdg6" />
            <span data-id="element-19" data-mp="1we2jr8477ybg">Get it now for $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}